module.exports = __webpack_public_path__ + "static/img/knowledgenew3.4962e390.jpg";